import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomSelect from '../Forms/CustomSelect/CustomSelect';
import InputItem from '../Forms/InputItem/InputItem';
import Fader from '../Loaders/Fader';

import { sendVerification } from '../../../http/userAPI';
import { setNotify } from '../../../datastore/actions/actionActions';
import { PROTOCOL_TYPES, PROVIDER_TYPES } from '../../../util/constants/AppConstants';

import SuccessIcon from '../../../assets/images/icons/check-mark.svg';
import WarningIcon from '../../../assets/images/icons/warning.svg';
import CloseIcon from '../../../assets/images/icons/close.svg';
import './EmailSettingItem.scss';

const EmailSettingItem = ({ email, index, initialEmailSettings, emailSettings, setEmailSettings }) => {
  const [loading, setLoading] = useState(false);

  const config = useSelector((state) => state.config.config);

  const dispatch = useDispatch();

  const emailExists = initialEmailSettings.find(
    (e) =>
      e.type === email.type &&
      e.provider === email.provider &&
      (email.provider !== 'Other' || (email.provider === 'Other' && e.mailServer === email.mailServer)) &&
      e.email === email.email &&
      email.email !== '',
  );

  const onChange = (field, value) => {
    const updatedEmails = [...emailSettings];
    updatedEmails[index][field] = value;
    setEmailSettings(updatedEmails);
  };

  const resendVerification = async () => {
    setLoading(true);

    const res = await sendVerification(config, email.id);

    if (res.status === 201) {
      dispatch(
        setNotify({
          status: true,
          type: 'success',
          title: 'Success',
          message: 'Email verification has been successfully sent',
        }),
      );
      setLoading(false);
    } else {
      dispatch(
        setNotify({
          status: true,
          type: 'error',
          title: 'Error',
          message: 'Email verification could not be sent. Please try again later',
        }),
      );
    }
  };

  const onRemove = () => {
    const updatedEmails = emailSettings.filter((_, i) => i !== index);
    setEmailSettings(updatedEmails);
  };

  return (
    <div className="settings__email">
      <div className="settings__status">
        <img src={emailExists && email.verified ? SuccessIcon : WarningIcon} />
        {emailExists ? (email.verified ? 'Connected' : 'Waiting Authentication') : 'Not Saved'}
      </div>
      <CustomSelect
        label="Type"
        options={PROTOCOL_TYPES}
        selectedOption={email.type}
        setSelectedOption={(value) => onChange('type', value)}
      />
      <CustomSelect
        label="Provider"
        options={PROVIDER_TYPES}
        selectedOption={email.provider}
        setSelectedOption={(value) => onChange('provider', value)}
      />
      {email.provider === 'Other' && (
        <InputItem
          label="Mail server"
          type="text"
          onChange={(e) => onChange('mailServer', e.target.value)}
          value={email.mailServer}
        />
      )}
      <InputItem label="Email" type="text" onChange={(e) => onChange('email', e.target.value)} value={email.email} />
      {!['Gmail', 'Outlook', 'Office 365'].includes(email.provider) && (
        <InputItem
          label="Password"
          type="password"
          onChange={(e) => onChange('password', e.target.value)}
          value={email.password}
        />
      )}
      {emailExists &&
        !email.verified &&
        (loading ? (
          <Fader size={22} />
        ) : (
          <span className="settings__link" onClick={resendVerification}>
            Resend email verification
          </span>
        ))}
      {emailSettings.length > 1 && <img className="settings__delete" src={CloseIcon} onClick={onRemove} />}
    </div>
  );
};

export default EmailSettingItem;
